import { AppLayout } from '@/AppLayout';
import { withPathnameWatcher } from './withPathnameWatcher';

const WatchedAppLayout = withPathnameWatcher(AppLayout);

export default WatchedAppLayout;
